module.exports = __webpack_public_path__ + "prod/1.42.2/media/e-commerce.97722246.mp4";